import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const SetPassword = () => {
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    // Check if user is already confirmed
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession()
      if (session?.user?.email_confirmed_at) {
        navigate('/dashboard')
      }
    }
    checkSession()
  }, [navigate])

  const handleSetPassword = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage('')

    try {
        const urlParams = new URLSearchParams(window.location.hash.substring(1)); // Remove the leading #
        const refreshToken = urlParams.get('refresh_token');
        
        if (!refreshToken) {
            throw new Error('Refresh token is missing');
        }
        
        await supabase.auth.refreshSession({ refresh_token: refreshToken });
        
        const { data, error } = await supabase.auth.updateUser({
        password: password
      })

      if (error) throw error

      setMessage('Account setup completed successfully!')
      navigate('/dashboard')
    } catch (error) {
      setMessage(`Error: ${error.message}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-md mx-auto mt-8 p-6 bg-white rounded shadow">
      <h2 className="text-2xl mb-4">Set Your Password To Continue</h2>
      <form onSubmit={handleSetPassword}>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Choose a password"
          className="w-full p-2 mb-4 border rounded"
          required
          minLength={8}
        />
        <button
          type="submit"
          disabled={loading}
          className="w-full p-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          {loading ? 'Processing...' : 'Complete Setup'}
        </button>
      </form>
      {message && (
        <p className={`mt-4 ${message.includes('Error') ? 'text-red-500' : 'text-green-500'}`}>
          {message}
        </p>
      )}
    </div>
  )
}

export default SetPassword;
